@if (initialized) {
  <div class="title">{{smt.bid_item?.item}}</div>
  <div class="caption">{{smt.material_test?.name}}</div>
  <div class="mat-body">
    @switch (smt.status) {
      @case ('draft') {
        Draft by {{smt.createdBy?.name}}
      }
      @case ('sent_to_lab') {
        Request sent to lab
      }
      @case ('lab_scheduled') {
        Lab visit on {{smt.request_date | dateFormat : 'MMMM DD'}}
      }
      @case ('lab_activity_completed') {
        Waiting for lab report
      }
      @case ('updated_report') {
        Lab report uploaded
      }
      @case ('passed') {
        <mat-icon style="color: green;">done</mat-icon>  Passed
      }
      @case ('failed') {
        <mat-icon style="color: red;">error_outline</mat-icon> Failed
      }
      @case ('cancelled') {
        <mat-icon style="color: orange;">close</mat-icon> Cancelled
      }
    }
  </div>
}
